import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface LimitPriceInputProps {
  limitPrice: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDecrease: () => void;
  onIncrease: () => void;
}

export function LimitPriceInput({
  limitPrice,
  onChange,
  onDecrease,
  onIncrease,
}: LimitPriceInputProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        sx={{
          fontSize: '0.875rem',
          fontWeight: 600,
          color: 'text.primary',
          mb: 1,
        }}
      >
        {t('trade.limitPrice', { defaultValue: 'Limit Price' })}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          size="small"
          onClick={onDecrease}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            width: 40,
            height: 40,
          }}
        >
          <RemoveIcon />
        </IconButton>
        <TextField
          size="small"
          value={limitPrice}
          onChange={onChange}
          InputProps={{
            endAdornment: <InputAdornment position="end"></InputAdornment>,
          }}
          sx={{
            flex: 1,
            '& input': {
              textAlign: 'center',
              fontWeight: 600,
              fontSize: '0.875rem',
              py: 1,
            },
          }}
        />
        <IconButton
          size="small"
          onClick={onIncrease}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            width: 40,
            height: 40,
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
